import { render, staticRenderFns } from "./ImportarRateios.vue?vue&type=template&id=509b521e&scoped=true&"
import script from "./ImportarRateios.vue?vue&type=script&lang=js&"
export * from "./ImportarRateios.vue?vue&type=script&lang=js&"
import style0 from "./ImportarRateios.vue?vue&type=style&index=0&id=509b521e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b521e",
  null
  
)

component.options.__file = "ImportarRateios.vue"
export default component.exports